import { useCallback, useEffect, useRef } from 'react';
import { SessionProgress } from './SessionProgress.tsx';
import { SignInPrompt } from './SignInPrompt.tsx';
import { useSignIn } from './use-sign-in.ts';

export const LoginPage = ({ returnTo }: { returnTo: string }) => {
  const signIn = useSignIn(
    useCallback(() => returnTo, [returnTo]),
    'redirecting',
  );
  const { start } = signIn;
  const redirected = useRef(false);

  useEffect(() => {
    if (redirected.current) return;
    redirected.current = true;
    start();
  }, [start]);

  if (signIn.attempt === 'redirecting') return <SessionProgress stage="signIn" />;
  return (
    <SignInPrompt
      stage="signIn"
      titleKey="shell.signInTitle"
      descriptionKey="shell.signInDescription"
      signIn={signIn}
    />
  );
};
